/* eslint-disable */
import axios from "axios";
import "/src/assets/css/animate.css";
import "/src/assets/css/style.css";
import moment from "moment";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import store from "../../store/index";
import jwt_decode from "jwt-decode";
import VPagination from "@hennge/vue3-pagination";
import customModal from "../customModal/customModal.vue";
import CraModal from "../CraManagement/CraScheduleModal.vue";
import CraAddEditModal from "../CraManagement/CraAddEditModal.vue";

// let testarray= [];
export default {
  name: "schedulelist",
  components: { VPagination, customModal, CraModal, CraAddEditModal },
  async mounted() {

    this.headerValues = {
      headers: {
        Authorization: "Bearer " + this.idToken,
        "Content-Type": "application/json",
      },
    };
    this.defaultdate = localStorage.getItem("dateformat");
    window.addEventListener("studyIdChanged", async (event) => {
      this.defaultdashboard = store.getters.getdefaultdashboard;
      console.log("StudyIDChanged into" + event.detail.storage);
      // window.location.reload();
      // await this.loadstudy();
      this.roleprivileges = await store.getters.getRolesprivilegeData;
      this.valnow = await store.getters.getStudyIs;

      this.getCraScheduleList();
      this.getVisitTypes();
      this.getsites();

    });
    this.defaultdashboard = store.getters.getdefaultdashboard;
    this.sndcharts = null;
    // await this.loadstudy();
    this.roleprivileges = await store.getters.getRolesprivilegeData;
    this.valnow = await store.getters.getStudyIs;
    this.getVisitTypes();
    this.getCraScheduleList();
    this.getsites();


    await this.countofloadSiteRiskMetrics();
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      idToken: store.getters.getIdToken,
      headerValues: {},
      selectedcolumnobj: { 'CRA ID': true, 'CRA Visit Type': true, 'Monitoring Mode': true, 'Site Code': true, 'Planned Date': true, 'Actual Date': true, 'Immediate Date': true, 'Triggered By': true, 'Status': true },
      // loadCraSchedule: false,
      sites: [],
      currentPage: 1,
      data: [],
      pageSize: 10,
      totalCount: 0,
      craScheduleId: "",
      totalPages: 0,
      SortProperty: "",
      SortOrder: 1,
      craScheduleList: [],
      showCraModel: false,
      loadingCraSchedule: false,
      selectedSite: null,
      visitTypes: [],
      searchField: {
        craVisitType: "",
        status: "",
        siteCode: ""
      },
      showCreateCraModal: false,
      editingCraId: null,
      sites: [],
    };
  },
  methods: {

    formatdatetime(data) {
      if (data) {
        return moment(data).format(this.defaultdate)
      }
    },
    SortSelected(property) {
      console.log("SortPropChanged:", property);

      if (this.SortProperty === property) {
        this.SortOrder = this.SortOrder === 0 ? 1 : 0;
      } else {
        this.SortProperty = property;
        this.SortOrder = 0;
      }

      this.activeSortColumn = property;
      this.currentPage = 1;

      console.log(`Sorting by ${this.SortProperty}, order: ${this.SortOrder}`);

      this.getCraScheduleList();
    },


    async getCraScheduleList() {
      const idtoken = store.getters.getIdToken;
      const stdid = store.getters.getStudyIs;

      this.loadingCraSchedule = true;

      try {
        const res = await axios.get(
          `${this.baseurl}/forms/cra/craschedulelist`,
          {
            params: {
              StudyId: stdid,
              pageindex: this.currentPage,
              pagesize: this.pageSize,
              SortProperty: this.SortProperty,
              SortOrder: this.SortOrder,
              CraVisitType: this.searchField.craVisitType || null,
              SiteCode: this.searchField.siteCode || null,
              Status: this.searchField.status || null,
            },
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        this.craScheduleList = res.data.results || []; this.totalCount = res.data.totalCount; this.totalPages = Math.ceil(this.totalCount / this.pageSize);

      } catch (err) {
        console.error("error in getCraScheduleList", err);
        this.craScheduleList = [];
      } finally {
        this.loadingCraSchedule = false;
      }
    },
    async loadPage(page) {
      this.currentPage = page;
      await this.getCraScheduleList();
    },
    async loadCraSchedule() {
      try {
        const studyId = store.getters.getStudyIs;
        const idtoken = store.getters.getIdToken;
        const craId = jwt_decode(idtoken).email;

        const url = `${this.baseurl}/forms/cra/craschedulelist?StudyId=${studyId}&CraId=${craId}`;
        const response = await axios.get(url, this.headerValues);

        const results = response.data?.results || [];

        const grouped = {};

        results.forEach(item => {
          if (!item.plannedDate) return;

          const date = moment(item.plannedDate).format('YYYY-MM-DD');

          if (!grouped[date]) {
            grouped[date] = {
              start: date,
              end: date,
              allDay: true,
              visits: [],
              class: 'multi-visit'
            };
          }

          grouped[date].visits.push({
            siteCode: item.siteCode,
            monitoringMode: item.monitoringMode,
            visitType: item.craVisitType
          });
        });

        this.craEvents = Object.values(grouped);

      } catch (e) {
        console.error(e);
        this.craEvents = [];
      }
    },
    async EditCra(craScheduleId) {
      if (!craScheduleId || craScheduleId === "string") {
        console.error("Invalid ID:", craScheduleId);
        alert("Invalid schedule ID");
        return;
      }

      this.craScheduleId = craScheduleId;
      this.showCraModel = true;
    },

    async refreshCraList() {
      await this.getCraScheduleList();
    },
    closeCraModal() {
      this.showCraModel = false;
      this.craScheduleId = null;
    },
    async getVisitTypes() {
      const idtoken = store.getters.getIdToken;
      const res = await axios.get(
        `${this.baseurl}/forms/cra/getcravisittype`,
        { headers: { Authorization: `Bearer ${idtoken}` } }
      );
      this.visitTypes = res.data || [];
    },
    async getsites() {
      let idtoken = store.getters.getIdToken;
      let studyId = store.getters.getStudyIs;
      const res = await axios.get(
        `${this.baseurl}/management/site/getall`,
        {
          params: { studyId: studyId },
          headers: { Authorization: `Bearer ${idtoken}` }
        }
      );
      this.sites = res.data || [];
    },

    async DeleteCra(craScheduleId) {
      const idtoken = store.getters.getIdToken;
      if (confirm("Are you sure you want to delete this CRA?")) {

        try {
          await axios.delete(
            `${this.baseurl}/forms/cra/deletecra?id=${craScheduleId}`,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          );
          alert("CRA deleted successfully.");
          this.getCraScheduleList();
        } catch (error) {
          console.error("Error deleting CRA:", error);
        }
      }
    },

    search() {
      this.currentPage = 1;
      this.getCraScheduleList();
    },
    CreateCra() {
      this.editingCraId = null;
      this.showCreateCraModal = true;
    },
    EditCRA(Id, studyId) {
      this.editingCraId = Id;
      console.log("Editing CRA with ID:", Id);
      this.showCreateCraModal = true;
    },
    closeCranewModal() {
      this.showCreateCraModal = false;
      this.editingCraId = null;
    },
     ViewTasks(craScheduleId) {
      this.$router.push(`/crataskmanagement?craScheduleId=${craScheduleId}`);
      
    }

  },
};